<div class="container-fluid">
  <si-card class="h-100" [heading]="'RESULTS.TABLES.HEADING' | translate">
    <div class="card-body d-flex flex-column gap-3 w-100" body>
      @if (results()) {
        <si-collapsible-panel headerCssClasses="p-5">
          <div class="d-flex gap-3 align-items-center" si-panel-heading>
            <span> {{ 'RESULTS.TABLES.HEADING_ENERGY_CONSUMPTION' | translate }} </span>
          </div>
          <div class="w-100 d-block overflow-auto">
            <table class="overflow-auto table table-hover table-sm mt-3 w-100">
              <thead>
                <th>{{ 'RESULTS.TABLES.ROUND_TRIP' | translate }}</th>
                <th>{{ 'RESULTS.TABLES.ENERGY_CONSUMPTION' | translate }}</th>
                <th>{{ 'RESULTS.TABLES.ENERGY_RECUPERATION' | translate }}</th>
                <th>{{ 'RESULTS.TABLES.NET_ENERGY_CONSUMPTION' | translate }}</th>
                <th>{{ 'RESULTS.TABLES.BATTERY_ENERGY_THROUGHPUT' | translate }}</th>
              </thead>
              <tbody id="drivingTimesResultsTables">
                <tr>
                  <td>{{ resultEnergyConsumption().timetable_name }}</td>
                  <td>
                    {{ resultEnergyConsumption().energy_consumption_in_kWh }}
                  </td>
                  <td>
                    {{ resultEnergyConsumption().energy_recuperated_in_kWh }}
                  </td>
                  <td>
                    {{ resultEnergyConsumption().net_energy_consumption_in_kWh }}
                  </td>
                  <td>
                    {{ resultEnergyConsumption().battery_energy_throughput_in_kWh }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </si-collapsible-panel>
        <si-collapsible-panel headerCssClasses="p-5" class="w-100">
          <div class="d-flex gap-3 align-items-center" si-panel-heading>
            <span> {{ 'RESULTS.TABLES.HEADING_DRIVING_TIMES' | translate }} </span>
          </div>
          <div class="w-100 d-block overflow-auto">
            <table class="overflow-auto table table-hover table-sm mt-3 w-100">
              <thead>
                <th>{{ 'RESULTS.TABLES.DEPARTURE_STOP' | translate }}</th>
                <th>{{ 'RESULTS.TABLES.DESTINATION_STOP' | translate }}</th>
                <th>{{ 'RESULTS.TABLES.ABSOLUTE_POSITION' | translate }}</th>
                <th>{{ 'RESULTS.TABLES.RELATIVE_DISTANCE' | translate }}</th>
                <th>{{ 'RESULTS.TABLES.STOPPING_TIME' | translate }}</th>
                <th>{{ 'RESULTS.TABLES.TARGET_TRAVEL_TIME' | translate }}</th>
                <th>{{ 'RESULTS.TABLES.ACTUAL_TRAVEL_TIME' | translate }}</th>
                <th>{{ 'RESULTS.TABLES.DIFFERENCE' | translate }}</th>
                <th>{{ 'RESULTS.TABLES.CUMULATIVE_DIFFERENCE' | translate }}</th>
                <th>{{ 'RESULTS.TABLES.AVERAGE_SPEED' | translate }}</th>
                <th>{{ 'RESULTS.TABLES.SOE' | translate }}</th>
                <th>{{ 'RESULTS.TABLES.ENERGY_CONSUMPTION' | translate }}</th>
                <th>{{ 'RESULTS.TABLES.ENERGY_RECUPERATION' | translate }}</th>
                <th>{{ 'RESULTS.TABLES.NET_ENERGY_CONSUMPTION' | translate }}</th>
              </thead>
              <tbody id="drivingTimesResultsTables" class="overflow-auto">
                @for (resultLine of resultTable(); track $index) {
                  <tr>
                    <td>{{ resultLine.start_station_name }}</td>
                    <td>{{ resultLine.end_station_name }}</td>
                    <td class="text-center"
                      >{{ (resultLine.position_of_start_station_in_m / 1000).toFixed(2) }} →
                      {{ (resultLine.position_of_end_station_in_m / 1000).toFixed(2) }}</td
                    >
                    <td class="text-center">{{
                      (
                        (resultLine.position_of_end_station_in_m -
                          resultLine.position_of_start_station_in_m) /
                        1000
                      ).toFixed(2)
                    }}</td>
                    <td class="text-center">{{ resultLine.stopping_time_in_s }}</td>
                    <td class="text-center">{{ resultLine.expected_driving_time_in_s }}</td>
                    <td class="text-center">{{ resultLine.achieved_driving_time_in_s }}</td>
                    <td class="text-center">{{ resultLine.driving_time_difference_in_s }}</td>
                    <td class="text-center">
                      {{ resultLine.cumulated_driving_time_difference_in_s }}
                    </td>
                    <td class="text-center">{{ resultLine.mean_velocity_in_km_per_h }}</td>
                    @if (vehicleType() === 'BEMU') {
                      <td class="text-center">{{ resultLine.battery_SOE }}</td>
                    } @else {
                      <td class="text-center">{{ resultLine.h2level }}</td>
                    }
                    <td class="text-center">{{ resultLine.energy_consumption_in_kWh }}</td>
                    <td class="text-center">{{ resultLine.energy_recuperated_in_kWh }}</td>
                    <td class="text-center">{{ resultLine.net_energy_consumption_in_kWh }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </si-collapsible-panel>
      }
    </div>
  </si-card>
</div>
